module.exports = __webpack_public_path__ + "static/media/arrow-discount.635b18c2.svg";